// extracted by mini-css-extract-plugin
var _1 = "jhi1L";
var _2 = "mQY0z";
var _3 = "A5Mkg";
var _4 = "xEguG";
export { _1 as "base", _2 as "content", _3 as "loadingMessage", _4 as "main" }
